module.exports = __webpack_public_path__ + "img/capa1.8edb0d5b.webp";